import { Component, Input } from '@angular/core';
import { BehaviorSubject, filter, map } from 'rxjs';
import { Customer } from 'server/shared/models/customer';
import { Employment } from 'server/shared/models/employment';
import { filterIsNotEmpty } from '../../../helpers/filterIsNotEmpty';

@Component({
  selector: 'app-pooler-employment-details-table',
  templateUrl: './pooler-employment-details-table.component.html',
  styleUrls: ['./pooler-employment-details-table.component.scss'],
})
export class PoolerEmploymentDetailsTableComponent {
  employment$ = new BehaviorSubject<Employment | undefined>(undefined);
  @Input() set employment(employment: Employment | undefined) {
    this.employment$.next(employment);
  }
  get employment(): Employment | undefined {
    return this.employment$.getValue();
  }

  @Input() customer?: Customer;

  employmentCertificates$ = this.employment$.pipe(
    filter(filterIsNotEmpty),
    map((employment) => {
      if (!employment.certificates?.length) {
        return;
      }
      return employment.certificates.map((c) => c.displayName).join(', ');
    }),
  );

  constructor() {}
}
